var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-base-200",attrs:{"id":"app"}},[_c('meta',{attrs:{"name":"referrer","content":"no-referrer"}}),(_vm.$route.name !== 'login')?_c('magic-menu'):_c('div',{staticStyle:{"height":"100%"}},[_c('login')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }